<!-- 续费弹层 -->
<template>
<div class='wrap'>
  <!-- <el-dialog
  :hide-header="true"
  :visible.sync="dialogVisible"
  width="80%"
  custom-class="previewDialog"
  :show-close="false"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  > -->
  <div class="cont">
    <span class="tips-font">尊敬的5yoho用户，涉及马帮3.0供应商对账、供应商质量报告、降本绩效三大功能因您5yoho会员已到期页面不再展示相关数据，请联系对应的销售或者在线客服了解续费详情</span>
    <el-row :gutter="100" style="margin-top:30px">
      <el-col :span="10">
        <p class="gard-l">erp同步<span>5yoho</span>功能点</p>
        <el-image
      style="width: 100%; height: 150px"
      :src="erpImg"
      fit="cover"></el-image>
      </el-col>
      <el-col :span="12">
        <p class="gard-l"><span>5yoho</span>经销商端与供应商端管理流程介绍</p>
        <el-image
      style="width: 100%; height: 150px"
      :src="erpImg2"
      fit="cover"></el-image>        
      </el-col>
    </el-row>
  </div>

<!-- </el-dialog> -->
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
 dialogVisible: true,
 erpImg: require('../../../assets/erp1.png'),
 erpImg2: require('../../../assets/erp2.png'),
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped lang="less">
.wrap{
  margin-top: 100px;
      margin-left: 255px;
    margin-right: 25px;
  background: #fff;
  padding: 25px;
  .cont{
    width: 94%;
    margin-left: 3%;
    min-height: 400px;
  }
}
.tips-font{
  color: #f19240;
  font-size: 18px;
  font-weight: bold;
}
.gard-l{
    font-size: 20px;
  font-weight: bold;
  color: #000;
  span{
    color: #f19240;
  }
}
</style>
<style>
  .previewDialog .el-dialog__header {

    display: none !important;
  }
</style>